import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { List, Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'
// import { List, Button, Form, Icon } from 'semantic-ui-react'
import general from '../../../modulos/general';

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelLista = ({elementoI}) => {
  console.log(elementoI)
  return(
    <tr className=''>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.cantidad}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrUnidadDes}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrProductoDes}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.valorDes?new Intl.NumberFormat('de-DE').format(elementoI.valorDes):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcDctoDes}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcIncrementoDes}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.valorDes?new Intl.NumberFormat('de-DE').format(elementoI.cantidad * ((elementoI.valorDes / ((100-elementoI.porcIncremento)/100)) * ((100-elementoI.porcDcto)/100))):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcIVADes}</td>
    </tr>
  )
};
const Lista = ({listI}) => {
  const nivel1Detalle = listI.map((elementoI, i) => <DetalleNivelLista elementoI={elementoI} 
       key={elementoI._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ListaT = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoPago" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Transferencia</option>
        <option>Consignación</option>
        <option>Efectivo</option>
      </select>
    </div>
  )
};

class VerPagosCli2 extends React.Component {    
  state={
    argsDocum: { file: "",
      trmPago: this.props.idLista.trmPago?this.props.idLista.trmPago:this.props.trmHoy,
      valorPago: 0,
      valorRetencion: 0,
      valorAjuste: 0,
      observacionAjuste: '',
      tipoPago: "Seleccionar...",
      _id: this.props.idLista._id,
    },
    confirmaAct: false, permiteBtn1: true, permiteBtn2: true, procBtn: 0, checked: false, 
    open: false, trmHoy: this.props.trmHoy
  } 

  handleChange = (ev, argsDocum) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      
      this.setState({argsDocum});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render (){
    const {checked, argsDocum, confirmaAct, open, trmHoy} = this.state;
    const a3555 = this.props.autorizacUA.findIndex( autorizac => autorizac === "3555" );
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    argsDocum.trmPago=argsDocum.trmPago.replace(",", ".")

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Facturación pendiente de pago
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            (ev)=>this.props.handleSubmit(ev, argsDocum):
            ()=>{}}
          >
            <div className="ui five column stackable grid">
              <div className="row container">
                <div className="column" width="30%">                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Coordinador: &nbsp;&nbsp;{this.props.idLista.nombreUsuarioOC}
                  </p>                 
                </div>
                <div className="column" width="40%">
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Empresa: &nbsp;&nbsp;{this.props.idLista.descrEmpresa}
                  </p>                
                </div>
                <div className="column" width="15%">                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Orden de compra: &nbsp;&nbsp;{this.props.idLista.numOrdenCompra}
                  </p>                 
                </div>
                <div className="column" width="15%">
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Avance facturación: &nbsp;&nbsp;{this.props.idLista.numAvance}
                  </p>                
                </div>
              </div>
              <div className="row container">
                <div className="column" width="25%">
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Valor total: &nbsp;&nbsp;{new Intl.NumberFormat('de-DE').format(argsDocum.valorFact)}
                  </p>                
                </div>
                <div className="column" width="25%">
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Valor pagado: &nbsp;&nbsp;{new Intl.NumberFormat('de-DE').format(argsDocum.valorPagado)}
                  </p>                
                </div>
                <div className="column" width="25%">
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Saldo: &nbsp;&nbsp;{new Intl.NumberFormat('de-DE').format((argsDocum.valorFact-argsDocum.valorPagado))}
                  </p>                
                </div>
                <div className="column" width="25%">
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    TRM de hoy: &nbsp;&nbsp;{general.formatNum((trmHoy).toString())}
                  </p>                
                </div>
              </div>
            </div>
            <div className="column" width="100%">
              <p style={{color: '#302b63', align: 'center', fontSize: '1.0em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
              DATOS DE LA FACTURACION: 
              </p>                
            </div>
            <div className="ui six column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '20%', paddingTop: '0.8em'}}>                
                  <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Medio de pago</label>
                    <ListaT styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor del pago</label>
                      <input type='number' step="1" min="0" autoComplete="off" name="valorPago" id="valorPago" value={argsDocum.valorPago} placeholder='Valor pago' onChange={this.handleChange}/>
                    </Form.Field>                
                </div> 
                <div className="column" style={{width: '20%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor retención</label>
                      <input type='number' step="1" min="0" autoComplete="off" name="valorRetencion" id="valorRetencion" value={argsDocum.valorRetencion} placeholder='Valor retención' onChange={this.handleChange}/>
                    </Form.Field>                
                </div>
                <div className="column" style={{width: '20%', paddingTop: '0.8em'}}>
                    <Form.Field>
                    <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Valor ajuste</label>
                      <input type='number' step="1" min="0" autoComplete="off" name="valorAjuste" id="valorAjuste" value={argsDocum.valorAjuste} placeholder='Valor ajuste' onChange={this.handleChange}/>
                    </Form.Field>                
                </div> 
                <div className="column" style={{width: '20%', paddingTop: '0.8em'}}>
                  <Form.Field>
                  <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>TRM para recaudo</label>
                    <Form.Input type='number' step="0.01" min="0.00" autoComplete="off" name="trmPago" id="trmPago" value={argsDocum.trmPago} onChange={this.handleChange} placeholder='TRM' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'trmPago'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '100%', paddingTop: '0.8em'}}>
                  <Form.Field>
                  <label style={{color: 'black', fontSize: '1em', margin: '0.4em 0em 0em 0em'}}>Observaciones al ajuste</label>
                    <Form.Input autoComplete="off" name="observacionAjuste" id="observacionAjuste" value={argsDocum.observacionAjuste} onChange={this.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacionAjuste'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>             
              </div>  
            </div>
            <div style={{height: '20em', overflow: 'auto'}}>
              <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '56%'}}>Producto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Valor unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>% Dcto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>% Incremento</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Total producto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>% IVA</th>
                  </tr>
                </thead>
                <Lista listI={this.props.list5} handleClickidListaI={this.props.handleClickidListaI} />
              </table>
              <p></p>
            </div>

            {a3555!==-1 &&
              <div className="ui one column stackable grid">
                <div className="row container">
                <div className="column" style={{width: '100%', paddingTop: '0.8em'}}>
                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} 
                    permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} 
                    handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                  </div>
                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div> 
            }
         </Form>
        </div>
      </div>
    )
  }
}

// export default VerCotizacion2
export default compose(
  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),


)(VerPagosCli2)
